import React, {useContext} from "react";
import ROUTES from "../../config/Routes";
import i18next from "i18next";
import useStyles from "../../style/js-style/containers/doc-viewer/PanelThirdpartyStyle";
import {Link} from "react-router-dom";
import {Context} from "../../states/Store";
import {useParams} from "react-router";
import {Tooltip} from "@mui/material";
import clsx from "clsx";
import EAColorIcon from '../../components/common/EAColorIcon';

function PanelThirdparty({ thirdparty }) {
  const { classes } = useStyles();
  const state = useContext(Context);
  const { accountId } = useParams();
  const redirectLink = () => `/${accountId || state.account?.id}/${ROUTES.THIRDPARTY_DETAIL.replace(":thirdpartyId", thirdparty.thirdpartyId)}`;

  return (
    <div className={classes.rootDO}>
        <div style={{display: "flex", alignItems: "baseline"}}>
          <Tooltip title={thirdparty.thirdpartyName} arrow>
            <span className={clsx(classes.thirdName, classes.spreadTool)}>
              {thirdparty.thirdpartyName}
            </span>
          </Tooltip>
          <Link to={redirectLink}>
            <EAColorIcon icon={"open-page_green"} alt={i18next.t("open")} wrapperClass={classes.ml}/>
          </Link>
        </div>
    </div>
  );
}

export default PanelThirdparty;
